import { AgResourceLanguage } from '../types';
import { settingsPage as EnUsSettingsPage } from '../en-us/settingsPage';

export const settingsPage: AgResourceLanguage['settingsPage'] = {
  ...EnUsSettingsPage,
  title: 'Konto',
  emailAndPassword: {
    title: 'E-post & Lösenord',
    changePasswordButton: 'Byt Lösenord',
    emailChangeInfo: {
      informationText: 'E-post kan endast ändras via',
      linkText: 'Customer Happiness'
    }
  },
  userInfo: {
    editButton: 'Redigera',
    title: 'Fullständigt Namn'
  },
  modal: {
    changePassword: {
      cancelButton: 'Avbryt',
      confirmPasswordLabel: 'Bekräfta Lösenord',
      header: 'Byt Lösenord',
      infoBanner: 'Om du byter lösenord loggas du automatiskt ut',
      newPasswordLabel: 'Nytt Lösenord',
      saveButton: 'Spara',
      title: 'Byt Lösenord',
      success: 'Lösenordet har ändrats',
      reloginError: 'Något gick fel, du kommer automatiskt att loggas ut'
    },
    editFullName: {
      cancelButton: 'Avbryt',
      firstName: 'Förnamn',
      header: 'Redigera Fullständigt Namn',
      lastName: 'Efternamn',
      saveButton: 'Spara',
      title: 'Fullständigt Namn'
    }
  },
  constants: {
    FULL_NAME_SUCCESS: 'Fullständigt namn har ändrats framgångsrikt',
    PASSWORD_MATCH_MESSAGE: 'De lösenord du har angett matchar inte',
    SETTINGS_ERROR: 'Något gick fel. Försök igen',
    nameError: 'Måste innehålla minst 1 tecken',
    latinNameError: 'Måste endast innehålla latinska tecken',
    spacesNameError: 'Endast mellanslag är inte tillåtna',
    minLength: 'Måste innehålla minst 8 tecken',
    uppercase: '1 versal',
    lowercase: '1 gemen',
    number: '1 siffra',
    spacesPasswordError: 'Mellanslag är inte tillåtet',
    passwordCaption: 'Måste innehålla minst 8 tecken'
  }
};
